NtechApp.SignUpForm = function() {
    this._ajax = new NtechApp.Ajax();
    this._click = new NtechApp.TouchClickEvent();
    this._formDataParser = new NtechApp.FormDataParser();

    this._form = new NtechApp.ModalForm(NtechApp.ModalForm.CACHE);
    this._form.setFormView($("#signUpForm"));

    this._$form = null;

    this._businessLoader = null;
    this._businessOverlay = null;

    this._personalLoader = null;
    this._personalOverlay = null;

    this._formGrid = null;

    this._isSocialRegistrationType = false;
    this._socialRegistrationType = null;
    this._socialRegistrationId = null;
    this._socialRegistrationEmail = null;

    this._findIfSocialRegistrationType();
    this._bindEvents();
    this._openFormIfSocialRegistrationType();
};

NtechApp.SignUpForm.EVENT_WINDOW_RESIZE = "resize.NtechApp.SignUpForm";

NtechApp.proto(NtechApp.SignUpForm, {
    _findIfSocialRegistrationType: function() {
        var $socialRegistrationType = $("#socialRegistrationData");
        if($socialRegistrationType.length == 0) {
            $(this._form.getFormView()).find("#accountSelect").addClass("visibleAccountSelect");
            return;
        }

        $(this._form.getFormView()).find("#personalAccount").css({
            position: "static",
            visibility: "visible"
        });

        this._isSocialRegistrationType = true;
        this._socialRegistrationType = $socialRegistrationType.attr("data-socialRegistrationType");
        this._socialRegistrationId = $socialRegistrationType.attr("data-socialRegistrationId");
        this._socialRegistrationEmail = $socialRegistrationType.attr("data-socialRegistrationEmail");

        var $personalAccountForm = this._form.getFormView().find("form[name='personal_account']");
        var $facebookId = $personalAccountForm.find("#personal_account_facebookId");
        var $linkedInId = $personalAccountForm.find("#personal_account_linkedInId");
        var $email = $personalAccountForm.find("#personal_account_email_first");
        var $repeatEmail = $personalAccountForm.find("#personal_account_email_second");
        var $login = $personalAccountForm.find("#personal_account_login");

        $email.attr("disabled", "disabled");
        $repeatEmail.attr("disabled", "disabled");

        if(this._socialRegistrationType == "facebook")
            $facebookId.val(this._socialRegistrationId);
        else if(this._socialRegistrationType == "linkedIn")
            $linkedInId.val(this._socialRegistrationId);

        $email.val(this._socialRegistrationEmail);
        $repeatEmail.val(this._socialRegistrationEmail);
        $login.val(this._socialRegistrationEmail.split("@")[0]);
    },

    _clearSocialRegistrationFields: function() {
        if(!this._isSocialRegistrationType)
            return;

        this._isSocialRegistrationType = false;

        var $personalAccountForm = this._form.getFormView().find("form[name='personal_account']");
        var $facebookId = $personalAccountForm.find("#personal_account_facebookId");
        var $linkedInId = $personalAccountForm.find("#personal_account_linkedInId");
        var $email = $personalAccountForm.find("#personal_account_email_first");
        var $repeatEmail = $personalAccountForm.find("#personal_account_email_second");
        var $login = $personalAccountForm.find("#personal_account_login");

        $email.removeAttr("disabled", "disabled");
        $repeatEmail.removeAttr("disabled", "disabled");

        $facebookId.val("");
        $linkedInId.val("");
        $email.val("");
        $repeatEmail.val("");
        $login.val("");
    },

    _openFormIfSocialRegistrationType: function() {
        if(this._isSocialRegistrationType) {
            this._openForm();
        }
    },

    _bindEvents: function() {
        var me = this;
        var $el = $("body").find('[data-eventWatcher="auth"]');

        $(me._form).on(NtechApp.ModalForm.OPEN_ANIMATION_START, function() {
            me._$form.find(".scrollableFormContent").scrollTop(0);
            //if(me._formsGrid == null)
            me._centrifyFormsContent();
            if(me._formGrid != null)
                me._formGrid.reposition();
        });

        $(me._form).on(NtechApp.ModalForm.OPEN_ANIMATION_END, function() {
            //me._$form.find(".scrollableFormContent").scrollTop(0);
            //me._centrifyFormsContent();
            //if(me._formGrid != null)
            //    me._formGrid.reposition();
        });

        this._click.listen($el, '[data-eventAction="openSignupForm"]', function(event) {
            event.preventDefault();
            me._openForm();

            return false;
        });
    },

    _openForm: function() {
        var me = this;
        me._$form = me._form.getFormView();

        me._form.load("load_signup_form", function($form) { 
            me._$form = $form;

            // @todo -> listen for animation end event
            // Use this only with NtechApp.getVisibleHeight(
            // this._$form.find(".scrollableFormContent"));
            //var formAnimationEnd = 500;
            //setTimeout(function() {
                //me._centrifyAccountSelectContent();
                //me._formGrid.reposition();
            //}, formAnimationEnd);

            //me._centrifyFormsContent();
            me._bindFormEvents.call(me, $form);
        });
    },

    _bindFormEvents: function($form, showFn) {
        var me = this;

        var $formContent = $form.find(".formContent");
        var $scrollableFormContent = $form.find(".scrollableFormContent");

        var $personalAccountForm = $form.find("#personalAccount .accountForm");
        var $businessAccountForm = $form.find("#businessAccount .accountForm");

        this._personalLoader = new NtechApp.Loader(
            35, 35, "absolute", $personalAccountForm
        );
        this._personalOverlay = new NtechApp.Overlay(
            $personalAccountForm, {position: "absolute", height: "100% !important"}
        );

        this._businessLoader = new NtechApp.Loader(
            35, 35, "absolute", $businessAccountForm
        );
        this._businessOverlay = new NtechApp.Overlay(
            $businessAccountForm, {position: "absolute", height: "100% !important"}
        );

        if(this._isSocialRegistrationType)
            var selectedFilter = "showPersonalAccount";
        else 
            var selectedFilter = "showAccountSelect";

        me._formGrid = NtechApp.gridifier(me._$form.find(".formsGrid"), {
            class: "formGridItem",
            filter: {
                selected: selectedFilter,
                showAccountSelect: function (item) {
                    return $(item).hasClass("accountFormItem");
                },
                showPersonalRegistrationTypeSelect: function(item) {
                    return $(item).hasClass("personalRegistrationTypeFormItem");
                },
                showPersonalAccount: function (item) {
                    return $(item).hasClass("personalFormItem");
                },
                showBusinessAccount: function(item) {
                    return $(item).hasClass("businessFormItem");
                },
                showSignupSuccess: function(item) {
                    return $(item).hasClass("signupSuccessFormItem");
                }
            },
            toggle: "visibility",
            gridResizeDelay: 0
        }).appendNew();

        $(window).on(NtechApp.SignUpForm.EVENT_WINDOW_RESIZE, function() {
            setTimeout(function() {
                me._centrifyFormsContent();
                me._formGrid.reposition();
            }, 500);
        });

        me._click.listen($form.find("[data-closeForm]"), function(event) {
            me._unloadForm(true);
        });

        me._click.listen(this._$form, "[data-loadRegisterFormByAccountType]", function(event) {
            var loadFormType = $(event.target).attr("data-loadRegisterFormByAccountType");
            //var $registerButton = me._$form.find("[data-registerAccount]");

            if(loadFormType == "personalRegistrationType") {
                var filter = "showPersonalRegistrationTypeSelect";
                //$registerButton.attr("data-registerAccount", "personal");
            }
            else if(loadFormType == "business") {
                var filter = "showBusinessAccount";
                me._toggleLicenseConfirmButton(me._$form.find(".confirmBox > .icon"), true);
                //$registerButton.attr("data-registerAccount", "business");
            }

            me._formGrid.toggle("slideLeftOutRightIn");
            me._formGrid.filter(filter);
            //me._showAccountForm.call(me, filter);
            me._scrollFormToTop();
        });

        me._click.listen(this._$form, "[data-returnFromPersonalRegistrationTypeSelect]", function(e) {
            me._formGrid.toggle("slideLeftInRightOut");
            me._formGrid.filter("showAccountSelect");
            me._scrollFormToTop();
        });

        me._click.listen(this._$form, "[data-continuePersonalRegistrationWithEmail]", function(e) {
            var $emailInput = me._$form.find("#personal_account_email_first");
            var emailValue = $emailInput.val();

            if(emailValue.length == 0) {
                NtechApp.info.on("Error: please enter your email.", 3000);
                return;
            }

            if(emailValue.indexOf("@") === -1) {
                NtechApp.info.on("Error: please enter valid email: 'name@domain.ext'", 3000);
                return;
            }

            me._toggleLicenseConfirmButton(me._$form.find(".confirmBox > .icon"), true);
            me._formGrid.toggle("slideLeftOutRightIn");
            me._formGrid.filter("showPersonalAccount");
            me._scrollFormToTop();
        });

        me._click.listen(this._$form, "[data-returnFromPersonalRegistration]", function(e) {
            me._formGrid.toggle("slideLeftInRightOut");
            me._formGrid.filter("showPersonalRegistrationTypeSelect");

            me._clearSocialRegistrationFields();
            me._scrollFormToTop();
        });

        me._click.listen(this._$form, "[data-returnFromBusinessRegistration]", function(e) {
            me._formGrid.toggle("slideLeftInRightOut");
            me._formGrid.filter("showAccountSelect");

            me._scrollFormToTop();
        });

        me._click.listen(this._$form.find(".confirmBox"), function(event) {
            var $icon = $(event.target).closest(".confirmBox").find(".icon");
            me._toggleLicenseConfirmButton($icon);
        });

        me._click.listen(this._$form.find(".confirmBox .termsLink"), function(event) {
            event.stopPropagation();
        });

        me._click.listen(this._$form, "[data-registerPersonalAccount]", function(event) {
            me._registerPersonalAccount();  
        });

        me._click.listen(this._$form, "[data-registerBusinessAccount]", function(event) {
            me._registerBusinessAccount();
        });

        me._click.listen(this._$form, ".formErrors", function(event) {
            $(event.target).closest(".formErrors").css("display", "none");
        });

        me._click.listen(me._$form.find("#signupSuccess"), "[data-finishButton]", function() {
            me._unloadForm(true);
            me._formGrid.toggle("slideLeftInRightOut");
            me._formGrid.filter("showAccountSelect");
        });

        me._click.listen(me._$form.find("[data-selectAccountTab]"), function(e) {
            var $item = $(e.target).closest("[data-selectAccountTab]");
            var tab = $item.attr("data-selectAccountTab");

            me._$form.find("[data-selectAccountTab]").removeClass("selected");
            $item.addClass("selected");

            me._$form.find(".accountTabItem").css("display", "none");
            me._$form.find("[data-accountTab='" + tab + "']").css("display", "block");
        });
    },

    _scrollFormToTop: function() {
        var me = this;
        setTimeout(function() {
            NtechApp.scrollItemTo(me._$form.find(".scrollableFormContent"), 0, false, 200);
        }, 20);
    },

    _unloadForm: function(keepEvents) {
        var keepEvents = keepEvents || false;
        this._form.unload();

        if(!keepEvents) {
            $(window).off(NtechApp.SignUpForm.EVENT_WINDOW_RESIZE);
            this._formGrid.destroy();
            this._form.destroy();
        }
    },

    _centrifyFormsContent: function() {
        //var formHeight = this._$form.outerHeight(); 
        //var formContentHeight = formHeight - (this._$form.find(".formHeading").outerHeight());
        //var formContentVpHeight = formHeight - (this._$form.find(".formHeading").outerHeight());
        //formContentVpHeight -= this._$form.find(".formControls").outerHeight();
        //formContentVpHeight = NtechApp.getVisibleHeight(this._$form.find(".scrollableFormContent"));

        var vpHeight = $(window).height();
        var formHeadingHeight = this._$form.find(".formHeading").outerHeight();
        vpHeight -= formHeadingHeight;

        var me = this;
        $.each(this._$form.find(".formGridItem .formVerticalAligner"), function() {
            var $verticalAligner = $(this);
            var formContentHeight = $verticalAligner.find(".formContentWrap").outerHeight();
            
            if(formContentHeight > vpHeight)
                $verticalAligner.css("padding-top", "0px");
            else {
                var marginTop = (vpHeight - formContentHeight) / 2;
                $verticalAligner.css("padding-top", marginTop + "px");
            }

            // if(selectFormHeight > formContentVpHeight || NtechApp.isMobile599())
            // if(formContentHeight > formContentVpHeight) {
            //     $verticalAligner.css("height", "auto");
            // }
            // else {
            //     var bottomOffset = 12;
            //     formContentVpHeight -= bottomOffset;

            //     $verticalAligner.css("height", formContentVpHeight + "px");
            // }
        });
    },

    // _showItems: function($items) {
    //     $.each($items, function() {
    //         if(NtechApp.dom.hasAttribute($(this).get(0), "data-inline"))
    //             $(this).css("display", "inline-block");
    //         else
    //             $(this).css("display", "block");

    //         NtechApp.sizesResolver.flushComputedStyles($(this));
    //     });

    //     $items.removeClass("fadeEffectHidden");
    // },

    // _hideItems: function($items) {
    //     $items.addClass("fadeEffectHidden");
    //     setTimeout(function() {
    //         $.each($items, function() {
    //             if ($(this).hasClass("fadeEffectHidden"))
    //                 $(this).css("display", "none");
    //         });
    //     }, 400);
    // },

    //_showAccountForm: function(formFilter) {
    //    this._formGrid.toggle("slideLeftOutRightIn");
    //    this._formGrid.filter(formFilter);
        //this._showItems(this._$form.find(".formControl"));
    //},

    // _showAccountSelectForm: function() {
    //     this._formGrid.toggle("slideLeftInRightOut");
    //     this._formGrid.filter("showAccountSelect");
    //     this._hideItems(this._$form.find(".formControl"));
    // },

    _toggleLicenseConfirmButton: function($button, forceOff) {
        var forceOff = forceOff || false;

        if($button.hasClass("selectedBox") || forceOff) {
            $button.removeClass("selectedBox");
            this._$form.find("[data-registerAccount]").addClass("inactiveControl");
        }
        else {
            $button.addClass("selectedBox");
            this._$form.find("[data-registerAccount]").removeClass("inactiveControl");
        }
    },

    _enableLoader: function() {
        if(this._formGrid.get('filter').selected == "showPersonalAccount") {
            this._personalLoader.on();
            this._personalOverlay.on();
        }
        else if(this._formGrid.get('filter').selected == "showBusinessAccount") {
            this._businessLoader.on();
            this._businessOverlay.on();
        }
    },

    _disableLoader: function() {
        if(this._formGrid.get('filter').selected == "showPersonalAccount") {
            this._personalLoader.off();
            this._personalOverlay.off();
        }
        else if(this._formGrid.get('filter').selected == "showBusinessAccount") {
            this._businessLoader.off();
            this._businessOverlay.off();
        }
    },

    _registerPersonalAccount: function() {
        this._registerAccount(
            this._$form.find("form[name='personal_account']"),
            this._$form.find("[data-personalConfirmButton]")
        );
    },

    _registerBusinessAccount: function() {
        this._registerAccount(
            this._$form.find("form[name='business_account']"),
            this._$form.find("[data-businessConfirmButton]")
        );
    },

    _registerAccount: function($form, $confirmButton) {
        var me = this;

        if(!$confirmButton.hasClass("selectedBox")) {
            NtechApp.info.on("You have to agree our terms of service before proceed.", 2500);
            return;
        }

        this._enableLoader();
        var formData = {
            accountData: this._formDataParser.getFormJSON($form)
        };

        this._ajax.post({
            url: Routing.generate("save_signup_form"),
            data: formData,
            onSuccess: function(data) {
                if(me._isSocialRegistrationType) {
                    window.location = NtechApp.config.baseUrl + Routing.generate('activate_social_account', {
                        accountId: data.accountId
                    });
                    return;
                }

                me._$form.find("#signupSuccess .accountForm").html($.parseHTML(data.signupSuccessHtml));
                //me._hideItems(me._$form.find(".formControl"));

                // Updating content after inserting HTML
                me._centrifyFormsContent();
                me._formGrid.reposition();
                me._formGrid.filter("showSignupSuccess");
            },
            onError: function(errors) {
                var $formErrors = me._$form.find(".formErrors");
                var html = "";

                $formErrors.find(".errorBody").children().remove();
                for(var key in errors) {
                    var errText = errors[key];
                    html += "<p>" + errText + "</p>";
                }

                $formErrors.find(".errorBody").append($.parseHTML(html));
                $formErrors.css("display", "block");
            },
            onComplete: function() {
                me._disableLoader();
            }
        });
    }
});